export const SUBURBS = [
  "Melbourne CBD",
  "Carlton",
  "Fitzroy",
  "Collingwood",
  "Richmond",
  "South Yarra",
  "Prahran",
  "Toorak",
  "St Kilda",
  "Brighton",
  "Brunswick",
  "Southbank",
  "Chelsea",
  "Northcote",
  "Hawthorn",
  "Camberwell",
  "Kew",
  "Malvern",
  "Glen Iris",
  "Albert Park",
  "Port Melbourne",
  "Williamstown",
];

export const SERVICES = [
  { key: "interior", title: "Interior Painting", blurb: "Walls, ceilings, trim — flawless finishes inside every room." },
  { key: "exterior", title: "Exterior Painting", blurb: "Weather-tough coatings built for Melbourne's four-seasons-a-day." },
  { key: "residential", title: "Residential", blurb: "From single bedroom refresh to whole-home transformations." },
  { key: "commercial", title: "Commercial", blurb: "After-hours fit-outs. Zero downtime. Office, retail, hospitality." },
  { key: "consultation", title: "Colour Consultation", blurb: "Two-hour on-site colour reads with samples. No more repaints." },
  { key: "specialty", title: "Specialty Finishes", blurb: "Limewash, Venetian plaster, feature walls, decorative effects." },
];

export const SWATCHES = [
  { name: "Quarter Antique White", hex: "#EFE9DC" },
  { name: "Terracotta", hex: "#D85C3A" },
  { name: "Olive Grove", hex: "#6A7B61" },
  { name: "Charcoal", hex: "#1A1A1A" },
  { name: "Whitewash", hex: "#F2F2EF" },
  { name: "Ochre Sun", hex: "#C99A4B" },
  { name: "Slate Blue", hex: "#3D4F5C" },
  { name: "Burnt Brick", hex: "#8E3B2A" },
];

export const CONTACT = {
  phone: "0426677479",
  phoneDisplay: "0426 677 479",
  email: "Gurdeep@themelbournepainters.com.au",
  whatsapp: "61426677479",
  owner: "Gurdeep",
};
